import { useEffect } from 'react';

import { usePaginatedWorkloadReliabilityMetricsQuery } from 'hooks/queries/cost/usePaginatedWorkloadReliabilityMetricsQuery';

type UseAllPagesWorkloadReliabilityMetricsQueryArgs = {
  clusterId: string;
  startTime: string;
  endTime: string;
  timezone: string;
  enabled?: boolean;
};

export const useAllPagesWorkloadReliabilityMetricsQuery = ({
  clusterId,
  startTime,
  endTime,
  timezone,
  enabled = true,
}: UseAllPagesWorkloadReliabilityMetricsQueryArgs) => {
  const {
    workloads,
    isLoading,
    isFetching,
    error,
    refetch,
    hasNextPage,
    fetchNextPage,
  } = usePaginatedWorkloadReliabilityMetricsQuery({
    clusterId,
    startTime,
    endTime,
    timezone,
    enabled,
    pageLimit: 500,
  });

  // Automatically fetch all pages sequentially
  useEffect(() => {
    if (hasNextPage && !isFetching && !isLoading) {
      fetchNextPage();
    }
  }, [hasNextPage, isFetching, isLoading, fetchNextPage]);

  return {
    items: workloads,
    isFetching: isFetching || !!hasNextPage,
    error,
    refetch,
  };
};
